// ABOUTME: Defines the bulk action catalog available for each list module.
// ABOUTME: Keeps job-scoped bulk actions limited to job candidate surfaces.
export type BulkActionsType =
    | "applicant_Delete"
    | "applicant_addToJob"
    | "applicant_exportToFile"
    | "applicant_addTag"
    | "applicant_importFromFile"
    | "job_addTag"
    | "job_exportToFile"
    | "applicant_sendEmail"
    | "applicant_sendWhatsappTemplate"
    | "applicantjob_requestScreeningQuestionnaireWhatsapp"
    | "applicant_whatsappManualOptIn"
    | "applicantjob_addToStage"
    | "applicantjob_disqualify"
    | "applicantjob_requalify"
    | "applicantjob_changeRejectedStage"
    | "applicantjob_requestEvaluation"
    | "applicantjob_requestAssessment"
    | "applicantjob_aiMatching"
    | "applicantjob_exportToFile";

export interface IBulkActions {
    name: BulkActionsType;
    type: "online" | "offline";
}

export type BulkActionChangeStageOptions =
    | "disqualify"
    | "requalify"
    | "changeStage"
    | "changeRejectedStage";

export const getBulkChangeStageActionType = (
    action: BulkActionChangeStageOptions
): BulkActionsType => {
    switch (action) {
        case "changeStage":
            return "applicantjob_addToStage";
        case "disqualify":
            return "applicantjob_disqualify";
        case "requalify":
            return "applicantjob_requalify";
        case "changeRejectedStage":
            return "applicantjob_changeRejectedStage";
    }
};


const applicantListBulkActions: IBulkActions[] = [
    { name: "applicant_addToJob", type: "online" },
    { name: "applicant_importFromFile", type: "offline" },
    { name: "applicant_exportToFile", type: "offline" },
    { name: "applicant_addTag", type: "offline" },
    { name: "applicant_sendEmail", type: "offline" },
    { name: "applicant_sendWhatsappTemplate", type: "offline" },
    { name: "applicant_whatsappManualOptIn", type: "offline" },
    { name: "applicant_Delete", type: "offline" }
];

const jobListBulkActions: IBulkActions[] = [
    // { name: "job_addTag", type: "offline" },
    { name: "job_exportToFile", type: "offline" }
];

const applicantListFromJobInsideKanbanBulkActions: IBulkActions[] = [
    { name: "applicantjob_exportToFile", type: "offline" },
    { name: "applicant_addTag", type: "offline" },
    { name: "applicant_sendEmail", type: "offline" },
    { name: "applicant_sendWhatsappTemplate", type: "offline" },
    {
        name: "applicantjob_requestScreeningQuestionnaireWhatsapp",
        type: "offline"
    },
    { name: "applicant_whatsappManualOptIn", type: "offline" },
    { name: "applicantjob_addToStage", type: "online" },
    { name: "applicantjob_disqualify", type: "online" },
    { name: "applicantjob_requalify", type: "online" },
    { name: "applicantjob_changeRejectedStage", type: "online" },
    { name: "applicantjob_requestEvaluation", type: "offline" },
    { name: "applicantjob_requestAssessment", type: "offline" },
    { name: "applicantjob_aiMatching", type: "offline" }
];

const applicantListFromJobOutsideKanbanBulkActions: IBulkActions[] = [
    { name: "applicantjob_exportToFile", type: "offline" },
    { name: "applicant_addTag", type: "offline" },
    { name: "applicant_sendEmail", type: "offline" },
    { name: "applicant_sendWhatsappTemplate", type: "offline" },
    {
        name: "applicantjob_requestScreeningQuestionnaireWhatsapp",
        type: "offline"
    },
    { name: "applicant_whatsappManualOptIn", type: "offline" },
    { name: "applicantjob_requestEvaluation", type: "offline" },
    { name: "applicantjob_requestAssessment", type: "offline" },
    { name: "applicantjob_aiMatching", type: "offline" }
];

export const getBulkActionsList = (
    moduleName: string,
    planName: string,
    BulkActionsRemoveFromList: BulkActionsType[] = []
) => {
    let returnData: IBulkActions[] = [];
    switch (moduleName) {
        case "APPLICANTLIST":
            returnData = applicantListBulkActions;
            break;
        case "JOBLIST":
        case "JOBREQUESTLIST":
            returnData = jobListBulkActions;
            break;
        case "JOBAPPLICANTLISTFILTERKANBAN":
            returnData = applicantListFromJobInsideKanbanBulkActions;
            break;
        case "JOBAPPLICANTLISTJOBVIEW":
            returnData = applicantListFromJobOutsideKanbanBulkActions;
            break;
        case "REPORTSJOBS":
            returnData = jobListBulkActions.filter(
                (item) => item.name !== "job_exportToFile"
            );
            break;
        default:
            returnData = [];
            break;
    }
    returnData = returnData.filter(
        (item: IBulkActions) => !BulkActionsRemoveFromList.includes(item.name)
    );
    return returnData;
};
